import { ReactNode, useEffect } from 'react';

import {
  ArrowLeftIcon,
  Dialog,
  DialogContent,
  DialogProps,
  Grid,
} from '@forgeglobal/design-framework';
import BaseLayout from './BaseLayout';
import useStyles from './style';
import FixedLayout from './FixedLayout';

interface BaseDialogProps extends DialogProps {
  backgroundColor?: string;
  children: ReactNode;
  header?: ReactNode;
  footer?: ReactNode;
  footerHeight?: number;
  showCloseArrow?: boolean;
  shouldShowUser?: boolean;
  hideDisclaimer?: boolean;
  fixedLayout?: boolean;
  onClose: () => void;
  name: string;
}

const BaseDialog = ({
  showCloseArrow = true,
  shouldShowUser,
  onClose,
  open,
  backgroundColor,
  children,
  header,
  footer,
  footerHeight,
  name,
  hideDisclaimer,
  fixedLayout,
  ...rest
}: BaseDialogProps) => {
  const classes = useStyles({
    footerHeight: footerHeight,
  });

  useEffect(() => {
    return () => {
      // componentWillUnmount to remove style attribute which is blocking scroll
      // Ref: https://github.com/mui/material-ui/issues/897
      document.getElementsByTagName('body')[0].removeAttribute('style');
    };
  }, []);

  const Layout = fixedLayout ? FixedLayout : BaseLayout;

  return (
    <Dialog open={open} fullScreen disableEnforceFocus {...rest}>
      <DialogContent className={classes.content}>
        <Layout shouldShowUser={shouldShowUser} hideDisclaimer={hideDisclaimer}>
          {header}
          {showCloseArrow && (
            <div className={classes.arrowContainer}>
              <ArrowLeftIcon
                data-test-id="arrow-button"
                onClick={onClose}
                className={classes.arrow}
              />
            </div>
          )}
          <Grid
            container
            justifyContent="center"
            className={fixedLayout ? undefined : classes.innerContent}>
            {children}
          </Grid>
          {footer && (
            <Grid
              container
              alignContent="center"
              justifyContent="center"
              className={classes.footer}>
              {footer}
            </Grid>
          )}
        </Layout>
      </DialogContent>
    </Dialog>
  );
};

export default BaseDialog;
